import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface SidebarItemNextUniDriver extends BaseUniDriver {
  isSelected(): Promise<boolean>;
  isDisabled(): Promise<boolean>;
  suffixExists(): Promise<boolean>;
  prefixExists(): Promise<boolean>;
  getSkin(): Promise<'dark' | 'light'>;
  getText(): Promise<string>;
}
